<div class="source-detail-container">
    <div class="info">
        <div class="name">
            <svg [nTooltip]="event.objectDes" class="icon" nTooltipPlacement="top">
                <use [attr.xlink:href]="icon"></use>
            </svg>
            <div class="name-detail">
                <ng-container *ngIf="!loading">
                    <div (click)="click()" class="title" nTextTips nTextTipsPlacement="top">
                        {{detail.NAME}}
                    </div>
                    <!-- 微存储屏蔽所属租户-->
                    <div *ngIf="FeatureConfig.IsSupportVStoreService && (vstoreName || event.vstoreName || detail.vstoreName)"
                        style="display: flex;align-items: center">
                        <div (click)="clickvstoreName()" class="vstoreName" nTextTips
                            nTextTipsPlacement="bottom">
                            <svg class="icon vstore">
                                <use xlink:href="#infigo-solid-vStore"></use>
                            </svg>
                            {{vstoreName || event.vstoreName || detail.vstoreName}}</div>
                    </div>
                </ng-container>
                <app-skeleton *ngIf="loading" [height]="'45px'" [width]="'200px'"></app-skeleton>
            </div>
        </div>
        <!-- 微存储直通场景不展示容量列-->
        <div *ngIf="!SWITCH.IS_DIRECT_MODE && showPercentBar" class="line"></div>
        <div *ngIf="!SWITCH.IS_DIRECT_MODE && showPercentBar && !loading" class="percentBar">
            <n-percent-bar
                *ngIf="type==='lun'"
                [freeDesc]="str.freeCapacityRender | fn :( (+detail.CAPACITY) - (+detail.ALLOCCAPACITY))"
                [nTooltip]="lunCapacityTips"
                [size]="'large'"
                [threshold]="threSholdList"
                [usedDesc]="str.usedCapacityRender | fn :detail.ALLOCCAPACITY :detail.CAPACITY"
                [value]="capacityPercentData"
                nTooltipPlacement="bottom">
            </n-percent-bar>
            <n-percent-bar
                *ngIf="type==='lunGroup'"
                [freeDesc]="str.freeCapacityRender | fn :((+detail.CAPCITY) - (detail.allocatedCapacity))"
                [nTooltip]="lunGroupCapacityTips"
                [size]="'large'"
                [usedDesc]="str.usedCapacityRender | fn :detail.allocatedCapacity :detail.CAPCITY"
                [value]="capacityPercentData"
                nTooltipPlacement="bottom">
            </n-percent-bar>
            <n-percent-bar
                *ngIf="type==='host'"
                [freeDesc]="str.freeCapacityRender | fn :(+detail.capacity - detail.allocatedCapacity)"
                [nTooltip]="hostCapacityTips"
                [size]="'large'"
                [usedDesc]="str.usedCapacityRender | fn :detail.allocatedCapacity :detail.capacity"
                [value]="capacityPercentData"
                nTooltipPlacement="bottom">
            </n-percent-bar>
            <n-percent-bar
                *ngIf="type==='hostGroup'"
                [freeDesc]="str.freeCapacityRender | fn :(+detail.capacity - detail.allocatedCapacity)"
                [nTooltip]="hostCapacityTips"
                [size]="'large'"
                [usedDesc]="str.usedCapacityRender | fn :detail.allocatedCapacity :detail.capacity"
                [value]="capacityPercentData"
                nTooltipPlacement="bottom">
            </n-percent-bar>
            <n-percent-bar
                *ngIf="type==='fileSystem'"
                [freeDesc]="str.freeCapacityRender | fn :( (+detail.CAPACITY) - (+detail.allocatedPoolQuota))"
                [nTooltip]="fileSystemCapacityTips"
                [size]="'large'"
                [usedDesc]="str.usedCapacityRender | fn :detail.allocatedPoolQuota :detail.CAPACITY"
                [value]="capacityPercentData"
                nTooltipPlacement="bottom"></n-percent-bar>
        </div>
        <div *ngIf="loading" class="percentBar">
            <app-skeleton [height]="'46px'"></app-skeleton>
        </div>
    </div>
    <div class="vertical-line"></div>
    <app-base-info-list [data]="detail" [items]="baseInfo" [loading]="loading"></app-base-info-list>
</div>
<ng-template #lunCapacityTips>
    <n-kv *ngIf="detail">
        <n-kv-item [key]="str.common.totalCapacityLab">
            {{detail.CAPACITY | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="str.common.alloccCapacityLab">
            {{detail.ALLOCCAPACITY | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="str.common.dataProtectionLab" *ngIf="!FeatureConfig.IsHideProtection">
            {{detail.REPLICATION_CAPACITY | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item
            *ngIf="threSholdList.length > 0"
            [key]="str.common.alarmThresholdLab">
            {{detail.ISCSITHINLUNTHRESHOLD}}%
        </n-kv-item>
    </n-kv>
</ng-template>
<ng-template #lunGroupCapacityTips>
    <n-kv *ngIf="detail">
        <n-kv-item [key]="str.common.totalCapacityLab">
            {{detail.CAPCITY | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="str.common.alloccCapacityLab">
            {{detail.allocatedCapacity | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="str.common.dataProtectionLab" *ngIf="!FeatureConfig.IsHideProtection">
            {{detail.protectionCapacity | adaptUnit: 'Sector'}}
        </n-kv-item>
    </n-kv>
</ng-template>
<ng-template #hostCapacityTips>
    <n-kv *ngIf="detail">
        <n-kv-item [key]="hostsStrService.i18nLabel.capacityLab">
            {{(+detail.capacity || 0) | adaptUnit :'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="hostsStrService.i18nLabel.alloccCapacityLab">
            {{(+detail.allocatedCapacity || 0) | adaptUnit :'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="hostsStrService.i18nLabel.replicationCapacityLab" *ngIf="!FeatureConfig.IsHideProtection">
            {{(+detail.protectionCapacity || 0) | adaptUnit :'Sector'}}
        </n-kv-item>
    </n-kv>
</ng-template>
<ng-template #fileSystemCapacityTips>
    <n-kv *ngIf="detail">
        <n-kv-item [key]="str.common.totalCapacityLab">
            {{detail.CAPACITY | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item [key]="str.common.alloccCapacityLab">
            {{detail.allocatedPoolQuota | adaptUnit: 'Sector'}}
        </n-kv-item>
        <n-kv-item
            *ngIf="detail.CAPACITYTHRESHOLD > 0"
            [key]="str.common.alarmThresholdLab">
            {{detail.CAPACITYTHRESHOLD}}%
        </n-kv-item>
    </n-kv>
</ng-template>
